import { Appointment, AppointmentID } from "./Appointment";
import { Car, CarID } from "./Car";
import { CarCheckID } from "./CarCheck";
import { DealerLocationID } from "./DealerLocation";
import { Intervention, InterventionID } from "./Intervention";
import { QUESTION_RESULT_STATUSES, QuestionResult, QuestionResultID } from "./QuestionResult";
import { User, UserID } from "./User";

export type SnoozeID = number;

export type SnoozeNoteAttachmentID = number;

export enum SNOOZE_TYPES {
  NextVisitCustomer = 1,
  MakeOffer = 2,
  MakeNewAppointment = 3,
  RemindCustomer = 4
}

export enum SNOOZE_STATUSES {
  Deleted = 0,
  New = 1,
  InProgress = 2,
  Approved = 3,
  Declined = 4,
  Fixed = 5,
  Done = 6
}

export enum SNOOZE_DEPARTMENTS {
  Sales = 1,
  CCC = 2,
  BodyRepair = 3,
  External = 4,
  Digital = 5,
  Parts = 6
}

export interface Snooze {
  created_on: string;
  updated_on: string;
  id: SnoozeID; // Snooze ID in Claire, each snooze ID represent a snooze log line
  question_result_id: QuestionResultID | null; // ID of the question result snoozes, null if an intervention is snoozed
  intervention_id: InterventionID | null; // Intervention ID of the intervention snoozed, null if a question result is snoozed
  snooze_type_id: SNOOZE_TYPES; // Type of snooze, see enumeration
  snooze_status_id: SNOOZE_STATUSES | null; // Status of the snooze, see enumeration
  snooze_date: string | null; // Date selected when snoozed
  snooze_department_id: SNOOZE_DEPARTMENTS | null; // Department assigned, see enumeration
  note: string; // Note entered when snoozed
  user_id: UserID; // ID of the user adding the snooze log line
  appointment_id: AppointmentID; // Appointment ID for this snooze
  dealer_location_id: DealerLocationID; // Dealer Location ID for this snooze
  car_id: CarID; // Car ID for this snooze
  user?: User;
  appointment?: Appointment;
  intervention?: Intervention;
  question_result?: QuestionResult;
  car?: Car;
  car_check_id?: CarCheckID;
  note_attachments?: string[];
  question_result_status?: QUESTION_RESULT_STATUSES;
}

export interface SnoozeType {
  id: SNOOZE_TYPES;
  name: string; // Name of the snooze type
}

export interface SnoozeStatus {
  id: SNOOZE_STATUSES;
  name: string;
}

export interface SnoozeDepartment {
  id: SNOOZE_DEPARTMENTS;
  name: string;
}

export interface SnoozeNoteAttachment {
  created_on: string;
  id: SnoozeNoteAttachmentID;
  url: string; // Url of the SnoozeNoteAttachment
  snooze_id: SnoozeID; // Identifier of the Snooze row where the note was added
}
